import type { ReactElement } from 'react'

import { getSessionJoinRedirectUrl } from '@/client/services/url'

import TrackEventButton from '@/components/UI/TrackEventButton'

export default function JoinSessionButton({
  isHost,
  sessionId,
  topicName,
  isDisabled = false,
  onClick,
}: {
  isHost: boolean
  sessionId: number
  topicName: string
  isDisabled?: boolean
  onClick: () => void
}): ReactElement {
  return (
    <TrackEventButton
      as="a"
      href={getSessionJoinRedirectUrl(sessionId, isHost)}
      rel="noreferrer"
      target="_blank"
      isDisabled={isDisabled}
      onClick={onClick}
      trackEvent={{ action: 'Session Join', extra: { topic: topicName, isHost } }}
      data-testid="session-join-continue"
    >
      Continue
    </TrackEventButton>
  )
}
